<template>
  <v-card 
    :color="slot ? 'white' : 'transparent'" 
  >
    <v-toolbar color="transparent" class="slot-toolbar" flat dense collapse>
      <v-spacer></v-spacer>
      <v-btn v-if="!slot" icon color="secondary" @click="editSlot">
        <v-icon>edit</v-icon>
      </v-btn>
      <v-menu
        v-else
        bottom
        left
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            dark
            icon
            v-bind="attrs"
            v-on="on"
            color="secondary"
            @mouseover="showMenu = true"
            @mouseleave="showMenu = false"
          >
            <v-slide-x-transition mode="out-in">
              <v-icon 
                v-if="showMenu || !app" 
                key="change_icon" 
                color="secondary"
              >
                settings_suggest
              </v-icon>
              <v-icon 
                v-else 
                key="app_icon" 
                :color="app.color || 'primary'"
              >
                {{ app.icon }}
              </v-icon>
            </v-slide-x-transition>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click="editSlot" dense>
            <v-list-item-title>Modifier</v-list-item-title>
          </v-list-item>
          <v-list-item @click="exportSlot" dense>
            <v-list-item-title>Exporter</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-sheet :min-height="height" color="transparent">
      <QlikBox 
        v-if="slot && integrator"
        :objectId="slot.qObjectId"
        :height="height"
        :integrator="integrator"
      />
      <v-icon 
        v-else-if="slot && !integrator"
        :size="height" 
        color="grey" 
      >
        search_off
      </v-icon>
      <v-icon 
        v-else
        :size="height" 
        color="primary"
      >
        insert_chart
      </v-icon>
    </v-sheet>
  </v-card>
</template>

<script>
import QlikBox from '@/components/Qlik/QlikBox'
import { DEFAULT_SLOTS } from '@/config/dashboard'
import { mapMutations, mapGetters, mapState } from 'vuex'
export default {
  name: 'DashboardSlot',
  components: { QlikBox },
  props: {
    slotKey: { 
      type: String, 
      required: false, 
      validator: function (value) {
        return Object.keys(DEFAULT_SLOTS).includes(value)
      }
    },
    height: { type: String, required: false, default: '300px' },
    type: { type: String, required: false, default: null }
  },
  data: () => ({
    showMenu: false
  }),
  computed: {
    integrator () {
      return this.slot && this.$qlik?.[this.slot.qAppId]?.integrator
    },
    app () {
      return this.apps.find(app => app.qAppId === this.slot?.qAppId) || null
    },
    ...mapGetters('dashboard', [
      'slots'
    ]),
    ...mapState('qlik', [
      'apps'
    ]),
    slot () {
      return this.slots[this.slotKey] 
    },
  },
  methods: {
    ...mapMutations('dashboard', [
      'setSlotEditing',
      'setSlotEditorType'
    ]),
    ...mapMutations('qlik', [
      'openExporter',
    ]),
    editSlot () {
      this.setSlotEditing(this.slotKey)
      this.setSlotEditorType(this.type)
    },
    exportSlot () {
      this.openExporter({
        qAppId: this.slot.qAppId,
        qObjectId: this.slot.qObjectId
      })
    }
  }
}
</script>

<style scoped>
.slot-toolbar {
  position: absolute;
  right: 0px;
  z-index: 5;
  width: 100%;
}
</style>